import Button from "components/base/Button";
import { CurrencyContext } from "CurrencyProvider";
import moment from "moment";
import { useContext } from "react";
import { GoHistory } from "react-icons/go";
import { useParams } from "react-router-dom";
import ComponentTitle from "../ComponentTitle";
import PriceWithCurrency from "../PriceWithCurrency";
import { calcSuitablePrice, childCost } from "../utils";
import { ProductCostContext } from "./Detail";

const ChildProductRow = ({ child, calcQty, itemsPerSet, showMore }) => {
  const { company } = useParams();
  const { defaultCurrency, showCostHistory } = useContext(ProductCostContext);
  const { latestExchangeRate } = useContext(CurrencyContext);
  const prices = child.product.prices.filter((i) => i.archivedAt === null);
  const hasPrices = prices.filter((i) => i.price > 0).length > 0;
  const rowSpan = hasPrices ? prices.length + 1 : 2;
  const sets = calcQty / itemsPerSet;
  const itemsQty = sets * child.qty;
  const suitablePrice = calcSuitablePrice(child.product, itemsQty, company);

  if (child.product.number === "DB107") {
    console.log("suitablePrice", suitablePrice.factory);
  }

  return (
    <>
      <tr className={prices.length === 0 ? "bg-pink-200" : ""}>
        <td className="border dark:border-gray-700 px-4" rowSpan={rowSpan}>
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center">
              <ComponentTitle product={child.product} />
              <div className="mx-2 whitespace-nowrap">&times; {child.qty}</div>
            </div>

            <div className="flex items-center space-x-2">
              <Button onClick={() => showCostHistory(child.product)}>
                <GoHistory size={14} />
              </Button>
            </div>
          </div>
          {showMore ? (
            <div className="whitespace-nowrap mt-1 text-teal-600">
              <div>
                {sets.toFixed(1)} sets, {itemsQty.toFixed(1)} items.{" "}
                {childCost(
                  child,
                  sets,
                  latestExchangeRate.supplierUsdToRmbRate,
                  defaultCurrency,
                  company,
                ).toFixed(3)}
              </div>
            </div>
          ) : null}
        </td>
        <td
          className="border dark:border-gray-700 px-4 text-right"
          rowSpan={rowSpan}
        >
          {child.product.moq > 0 ? child.product.moq : "-"}
        </td>
      </tr>
      {prices.length > 0 ? (
        prices.map((price, priceIndex) => {
          const using = suitablePrice && suitablePrice.id === price.id;
          return (
            <tr key={priceIndex} className={`${using ? "" : "opacity-30"}`}>
              <td
                className={`border dark:border-gray-700 px-4 text-center text-xs`}
              >
                ({price.company}) {price.factory ? price.factory.name : "-"}
              </td>
              <td className="border dark:border-gray-700 px-4 text-right">
                {price.minQty}
              </td>
              <td className="border dark:border-gray-700 px-4 text-right whitespace-nowrap">
                <PriceWithCurrency
                  price={price}
                  defaultCurrency={defaultCurrency}
                />
              </td>
              <td className="border dark:border-gray-700 px-4 text-right">
                {moment(price.supplierUpdatedAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={4}
            className="border dark:border-gray-700 px-4 text-right bg-pink-200 font-bold text-red-600"
          >
            No Cost.
          </td>
        </tr>
      )}
    </>
  );
};

export default ChildProductRow;
